import { Feedback, List, ListAlt, TableRestaurant } from "@mui/icons-material";
import { Fab, SpeedDial, SpeedDialAction, SpeedDialIcon, Stack } from "@mui/material";

type EndgameNavigationProps = {
  scrollToTable: () => void;
  scrollToOverviewResults: () => void;
  scrollToFeedback: () => void;
  scrollToStatistics: () => void;
};

export default function EndgameNavigation({
  scrollToTable,
  scrollToOverviewResults,
  scrollToFeedback,
  scrollToStatistics,
}: EndgameNavigationProps) {
  const sdaFabProps = {
    sx: {
      bgcolor: "primary.main",
      color: "white",
      ":hover": {
        bgcolor: "primary.main",
        transform: "scale(105%)",
      },
    },
  };
  return (
    <SpeedDial
      sx={{ position: "fixed", bottom: 16, left: 16 }}
      icon={<SpeedDialIcon />}
      ariaLabel={"quick navigation"}
      FabProps={{ size: "small" }}
    >
      <SpeedDialAction icon={<ListAlt />} onClick={scrollToStatistics} FabProps={sdaFabProps} />
      <SpeedDialAction icon={<Feedback />} onClick={scrollToFeedback} FabProps={sdaFabProps} />
      <SpeedDialAction icon={<List />} onClick={scrollToOverviewResults} FabProps={sdaFabProps} />
      <SpeedDialAction icon={<TableRestaurant />} onClick={scrollToTable} FabProps={sdaFabProps} />
    </SpeedDial>
  );
}
